import type { StoragePort } from '../domain/ports'

export class MemoryStorage implements StoragePort {
  private readonly values = new Map<string, string>()

  constructor(seed: Record<string, string> = {}) {
    Object.entries(seed).forEach(([key, value]) => this.values.set(key, value))
  }

  getItem(key: string): string | null {
    return this.values.get(key) ?? null
  }

  setItem(key: string, value: string): void {
    this.values.set(key, value)
  }

  removeItem(key: string): void {
    this.values.delete(key)
  }

  snapshot(): Readonly<Record<string, string>> {
    return Object.fromEntries(this.values.entries())
  }
}

export const getBrowserStorage = (): StoragePort => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) return window.localStorage
  } catch {
    // Privacy modes can expose localStorage while denying access to it.
  }
  return new MemoryStorage()
}
